import request from "./api_client";

const creationUrl = {
  // Organisation Create
  organisation_details: "/organisations",
  organisation_profile: "/organisation_profiles",
  organisation_contact: "/organisation_contact_infos",
  organisation_pre_contract: "/organisation_pre_contracts",
  organisation_general: "/organisation_general_details",
  organisation_contract: "/organisation_contract_phases",
  organisation_activity: "/organisation_activity_fields",
  organisation_business_developments: "/organisation_business_developments",
  file_upload: "/organisations/file_upload",
  // Employee - Create
  employee_contact_area: "/employees",
  employee_work_information: "/employee_work_infos",
  employee_coaching_capacity: "/employee_coaching_mentoring_capacities",
  employee_training_and_development: "/employee_training_developments",
  employee_mentoring_capacity: "/employee_coaching_mentoring_capacities",
  employee_coaching_profile: "/employee_coaching_mentoring_profiles",
  employee_facilitations: "/employee_facilitations",
  employee_assessments: "/employee_assessments",
  employee_gdprs: "/employee_gdprs",
  employee_file_upload: "/employees/file_upload",
  employee_personal_documents: "/employee_personal_documents",
  employee_backgrounds: "/employee_backgrounds",
  employee_coaching_backgrounds: "/employee_coaching_backgrounds",

  // Add new value to growing dropdown
  add_in_drop_down: "/add_in_drop_down",
  add_competency: "/competencies",
  // setup
  module_setup_create: "/module_setups/create_module",
  module_setups_new_feild: "module_setups/add_form_field",

  organisation_metrics_create: "organisation_metrics",
  add_metrics_to_organisation:
    "organisation_metrics/add_metrics_to_organisation",

  thematicsDoc: "/thematics/upload_documents",

  //coaching rate card
  coaching_rate_cards: "/rate_cards/create_available_region",
  coaching_rate_cards_external: "/rate_cards/create_external_rate_card",
  coaching_rate_cards_internal: "/rate_cards/create_internal_rate_card",
  // work_infos: '/partner_work_infos'

  // create crf section
  crf_form_sections: "/crf_form_sections",
  crf_fields: "/crf_fields",

  //create evaluation form
  evaluation_form_fields: "/evaluation_form_fields",

  // create crf answers
  crf_answers: "/crf_answers",
  coaching_agreement_form_answers: "/coaching_agreement_form_answers",

  // create evaluation form
  evaluation_answers: "evaluation_answers",

  // master template
  create_master_template: "master_templates",
  create_programme_info: "master_templates/create_program_info",
  create_commercial_billing: "master_templates/create_commercial_billing",
  change_header_name: "master_templates/change_header_name",

  //upload document
  upload_program_documents: "master_templates/upload_pgm_documents",

  //terms and policies
  create_terms_policies: "master_templates/create_terms_and_policies",

  //program flow setup
  create_program_flow: "master_templates/create_pgm_flow_setup",

  //PROGRAM
  program_info: "programmes/create_program_info",
  commercial_billing: "programmes/create_commercial_billing",
  program_documents: "programmes/upload_pgm_documents",
  terms_policies: "programmes/create_terms_and_policies",
  flow_setup: "programmes/create_pgm_flow_setup",
  create_program: "programmes",
  create_program_header: "programmes/change_header_name",

  //ASSIGNMENTS
  create_assignment: "assignments",
  assignment_commercial_billing: "assignments/create_commercial_billing",
  assignment_pgm_flow_setup: "assignments/create_pgm_flow_setup",
  assignment_pgm_documents: "assignments/upload_pgm_documents",
  assignment_terms_policies: "assignments/create_terms_and_policies",
  assignment_program_info: "assignments/create_program_info",
  create_assignment_header: "assignments/change_header_name",
  move_to_shortlist: "shortlisting_coaches/move_to_shortlist",
  move_to_chemistry: "shortlisting_coaches/move_to_chemistry",
  move_to_confirmed: "shortlisting_coaches/move_to_confirmed",
  partner_role_organisation_maps: "partner_role_organisation_maps",
  partner_role_programme_maps:
    "partner_role_organisation_maps/partner_role_programme_maps",
  create_assignment_alerts: "assignments/create_assignment_alerts",
  create_assignment_from_extension:
    "assignment_details/create_assignment_from_extension",

  //CAF
  coaching_agreement_form_sections: "coaching_agreement_form_sections",
  coaching_agreement_form_fields: "coaching_agreement_form_fields",

  //ASSIGNMENT SUMMARY
  create_SLA_detail: "assignment_summary/save_assignment_SLA_detail",

  //SLA
  create_SLA: "slas",
  select_organisation_for_SLA: "slas/select_organisations",

  // EMAIL
  send_email: "shortlisting_coaches/send_email",

  // FEEDBACK
  create_feedback: "feedbacks",

  upload_supporting_document: "invoices/upload_supporting_document",
  // REQUEST COACHES
  requestCoaches: "request_coaches",

  create_extension: "assignment_details/create_extension",

  //acuityFeedback
  acuityFeedback: "acuity_feedbacks",

  //shortlisting_coaches - send_email
  coachesSendEmail: "shortlisting_coaches/send_email",
  miFieldToggle: "management_information_fields/select_mi_field",
};
const serviceUrl = {
  CoachingProfileField: "partner_commission_informations",
  ProfileRole: "profile_roles",
  listingDropdowns: "/partner_profiles/listing_dropdowns",
};

function createData(formData, section, authHeaders) {
  return request({
    url: creationUrl[section],
    method: "POST",
    data: formData,
    headers: authHeaders,
  });
}

export default createData;
